<template>
  <div class="px-4 py-2 g-body-width g-safe-area">
    <div class="flex items-center justify-evenly w-full">
      <!-- 回看按钮 -->
      <div
        class="flex flex-col items-center justify-center gap-1 px-4 py-2 cursor-pointer"
        :class="{ 'opacity-30': lastCardDisabled }"
        @click="onLastCardClick"
      >
        <Tooltip
          :show="showLastCardGuide"
          trigger="manual"
          placement="top"
        >
          <span>{{ _t('learn.show_last_card') }}</span>

          <template #trigger>
            <Icon
              name="last-card"
              class="w-20px text-ld-text shrink-0"
            />
          </template>
        </Tooltip>
        <span class="text-xs text-gray-600">{{ _t('learn.review_last') }}</span>
      </div>

      <!-- 提示按钮 -->
      <div
        class="flex flex-col items-center justify-center gap-1 px-4 py-2 cursor-pointer"
        @click="emit('hint')"
      >
        <Icon
          name="card-info-edit"
          class="w-20px shrink-0 text-ld-text"
        />
        <span class="text-xs text-gray-600">{{ _t('learn.tip') }}</span>
      </div>

      <!-- 编辑/反馈按钮 -->
      <div
        class="flex flex-col items-center justify-center gap-1 px-4 py-2 cursor-pointer"
        @click="canEdit ? emit('edit') : emit('feedback')"
      >
        <Icon
          :name="canEdit ? 'card-content-edit' : 'nav-mine'"
          class="w-20px shrink-0 text-ld-text"
        />
        <span class="text-xs text-gray-600">
          {{ canEdit ? _t('learn.edit') : _t('learn.feedback') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  showLastCardGuide: boolean
  lastCardDisabled: boolean
  canEdit: boolean
}>()

const emit = defineEmits<{
  lastCard: []
  hint: []
  edit: []
  feedback: []
}>()

function onLastCardClick() {
  if (props.lastCardDisabled) {
    _message.info(_t('learn.first_card'))
    return
  }

  emit('lastCard')
}
</script>

<style scoped></style>
